// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `rails generate channel` command.

import { createConsumer } from "@rails/actioncable"

const consumer = createConsumer()

const originalOpen = consumer.connection.open
const originalUrl = consumer.url // Store the resolved connection URL

let isFetchingTicket = false
let currentTicket = null
let pendingOpenCalls = []

// Redefine the 'url' getter to dynamically include the ticket when available
Object.defineProperty(consumer, 'url', {
  get() {
    if (currentTicket) {
      const url = new URL(originalUrl, window.location.href)
      url.searchParams.set('ticket', currentTicket)
      return url.toString()
    }
    return originalUrl
  },
  configurable: true
})

consumer.connection.open = function() {
  const connection = consumer.connection
  const isConnectingOrOpen = connection.webSocket && 
    (connection.webSocket.readyState === WebSocket.CONNECTING || 
     connection.webSocket.readyState === WebSocket.OPEN)

  if (isConnectingOrOpen) {
    return originalOpen.call(connection)
  }

  if (currentTicket) {
    originalOpen.call(connection)
    currentTicket = null // Reset the single-use ticket immediately after connection is initiated
    return
  }

  pendingOpenCalls.push(arguments)

  if (!isFetchingTicket) {
    isFetchingTicket = true

    const headers = {
      'Content-Type': 'application/json'
    }
    if (window.gon && window.gon.auth_token) {
      headers['Authorization'] = window.gon.auth_token
    }

    const apiBase = (window.gon && window.gon.urls && window.gon.urls.api) || '/api'
    fetch(`${apiBase}/websocket_tickets`, {
      method: 'POST',
      headers: headers
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.json()
      })
      .then(data => {
        if (data && data.ticket) {
          currentTicket = data.ticket
        }
      })
      .catch(error => {
        console.error('Failed to retrieve WebSocket auth ticket:', error)
      })
      .finally(() => {
        isFetchingTicket = false
        const calls = pendingOpenCalls
        pendingOpenCalls = []
        calls.forEach(args => {
          connection.open.apply(connection, args)
        })
      })
  }
}

export default consumer
